import { render, staticRenderFns } from "./GalleryMobile.vue?vue&type=template&id=b84c33a6&scoped=true&"
import script from "./GalleryMobile.vue?vue&type=script&lang=js&"
export * from "./GalleryMobile.vue?vue&type=script&lang=js&"
import style0 from "./GalleryMobile.vue?vue&type=style&index=0&id=b84c33a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84c33a6",
  null
  
)

export default component.exports